import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ITipoTramite, ITipoTramiteActividad, TipoTramiteActividaDto } from '../../../../shared/interfaces/database/configuracion';
import { TipoTramiteActividaService } from '../../../../services/database/tipoTramiteActivida.service';

import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from 'primeng/inputnumber';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { AccessRole, ButtonColumnType, CustomTableComponent, DataColumnType, ICustomTable, IFooterColums, IHeader, LoadingPanelService, LocalService, Severity } from 'lib-base';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TipoTramiteService } from '../../../../services/database/tipoTramite.service';
import { firstValueFrom, forkJoin } from 'rxjs';
import { AdminTipoTramiteActividadHistorialComponent } from './admin-tipo-tramite-actividad-historial/admin-tipo-tramite-actividad-historial.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { ActividadBaseComponent } from './actividad-base.component';
import { AlertasDialogComponent } from '../../../../components/custom-work/other/alertas-dialog/alertas-dialog.component';

@Component({
  selector: 'app-admin-tipo-tramite-actividad',
  standalone: true,
  imports: [
    CommonModule, ReactiveFormsModule, FormsModule, TranslateModule, AdminTipoTramiteActividadHistorialComponent,
    TableModule, ButtonModule, DialogModule, DropdownModule, InputNumberModule, CheckboxModule, ConfirmPopupModule,
    CustomTableComponent, MultiSelectModule, ActividadBaseComponent, AlertasDialogComponent],
  providers: [ConfirmationService],
  template: `
<p-confirmPopup></p-confirmPopup>
<div>
	<custom-table [config]="customTable">
	</custom-table>
	<div class="flex justify-content-end gap-2">
		<p-button [label]="trans.cancelar" [outlined]="true" severity="secondary" [disabled]="btnGuardarDisable"
			(onClick)="onCancelarCambios()" />
		<p-button [label]="trans.guardar" [outlined]="true" severity="success" [disabled]="btnGuardarDisable"
			(onClick)="onGuardarCambios()" />
	</div>
</div>

<app-actividad-base *ngIf="tipoTramite" [tipoTramite]="tipoTramite" (onSubmitEvent)="onSubmitEvent()"></app-actividad-base>
<app-admin-tipo-tramite-actividad-historial></app-admin-tipo-tramite-actividad-historial>
<app-alertas-dialog [headerTitle]="'common.alertas' | translate"></app-alertas-dialog>

  `
})
export class AdminTipoTramiteActividadComponent implements OnInit {

  @Input() tipoTramiteId!: number;
  @Input() parentData !: ITipoTramite;//referencia para cambiar el estado de la columna de produccion

  tipoTramite !: ITipoTramite;
  dataset !: ITipoTramiteActividad[];
  role = AccessRole;
  trans: any = {};
  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;
  @ViewChild(AdminTipoTramiteActividadHistorialComponent) historico !: AdminTipoTramiteActividadHistorialComponent;
  @ViewChild(ActividadBaseComponent) actividadBaseComponent !: ActividadBaseComponent;

  btnGuardarDisable: boolean = true;

  get data(): ITipoTramiteActividad[] {
    return this.customTableComponent.data;
  }

  set data(value: ITipoTramiteActividad[]) {
    this.customTableComponent.data = value;
  }

  //Alertas
  @ViewChild(AlertasDialogComponent) alertasDialog !: AlertasDialogComponent;

  //tramites automaticos
  constructor(
    private readonly _tta: TipoTramiteActividaService, public readonly ls: LocalService, private readonly _tt: TipoTramiteService, private readonly _t: TranslateService,
    private readonly _ms: MessageService, private readonly _cs: ConfirmationService, private readonly _lps: LoadingPanelService,
  ) {

  }

  ngOnInit(): void {
    this.translate().then(() => { this.configTable(); });
    this.getTipoTramiteActividades();
    this.getTipoTramite();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      guardar: this._t.get('form.button.guardar'),
      cancelar: this._t.get('form.button.cancelar'),
      noCambiosFormulario: this._t.get('msg.noCambiosFormulario'),
      completeCamposRequeridos: this._t.get('msg.completeCamposRequeridos'),
      exito: this._t.get('common.exito'),
      advertencia: this._t.get('common.advertencia'),
      actividadesGuardadas: this._t.get('msg.actividadesGuardadas'),
      nuevaActividad: this._t.get('msg.nuevaActividad'),
      editarActividad: this._t.get('msg.editarActividad'),
      actividad: this._t.get('common.actividad'),
      orden: this._t.get('common.orden'),
      plazoFechaCierre: this._t.get('common.plazoFechaCierre'),
      automatico: this._t.get('common.tipoActividad'),
      tieneRespuestaDinamica: this._t.get('common.tieneRespuestaDinamica'),
      tieneInserciónDinamica: this._t.get('common.tieneInserciónDinamica'),
      alertas: this._t.get('common.alertas'),
    }));
  }

  configTable() {
    this.customTable = {
      header: {
      } as IHeader,
      columns: [
        {
          field: 'actividadCodificacion',
          header: this.trans.actividad,
          columnFilter: true,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: ''
          },
          dataType: DataColumnType.TEXT
        },
        {
          field: 'orden',
          header: this.trans.orden,
          sort: true,
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: ''
          },
          columnFilter: false,
          dataType: DataColumnType.NUMBER
        },
        {
          field: 'plazoFechaCierre',
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
            style: ''
          },
          header: this.trans.plazoFechaCierre,
          dataType: DataColumnType.NUMBER
        },
        {
          field: 'tipoDescripcion',
          class: 'font-13',
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold'
          },
          header: this.trans.automatico,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'tieneRespuestaDinamica',
          header: this.trans.tieneRespuestaDinamica,
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
          },
          dataType: DataColumnType.CHECK
        },
        {
          field: 'tieneInserciónDinamica',
          header: this.trans.tieneInserciónDinamica,
          columnmHeader: {
            class: 'text-left color-blue-2 font-13 font-bold',
          },
          dataType: DataColumnType.CHECK
        },
        {
          field: 'warnings',
          header: this.trans.alertas,
          icon: 'pi pi-info-circle',
          class: 'button-edit p-button-outlined pt-2 pb-2 pr-0 pl-0',
          width: '0rem',
          getSeverity: (data: ITipoTramiteActividad) => this.alertasGetSeverity(data),
          buttonType: ButtonColumnType.CUSTOM,
          onClick: (event: Event, data: ITipoTramiteActividad) => this.alertasMostrar(data),
        },
        {
          field: 'edit',
          header: '',
          width: '0rem',
          class: 'pt-2 pb-2 pr-1',
          buttonType: ButtonColumnType.EDIT,
          onClick: (event: Event, data: ITipoTramiteActividad) => this.openEditActividadModal(data),
          headerBtn: {
            icon: 'pi pi-history',
            class: 'pt-2 pb-2 pl-0 pr-1',
            severity: 'info',
            onClick: (event: Event) => this.abrirHistorial(),
          }
        },
        {
          field: 'delete',
          header: '',
          width: '0rem',
          class: 'pt-2 pb-2 pl-0',
          buttonType: ButtonColumnType.DELETE,
          onClick: (event: Event, data: ITipoTramiteActividad) => this.deleteConfirmation(event, data),
          disabled: !this.ls.hasRole(this.role.ADMIN_TRAM),
          headerBtn: {
            icon: 'pi pi-plus',
            class: 'pt-2 pb-2 pl-1 pr-0',
            onClick: (event: Event) => this.openNewActividadModal(),
          },
        }
      ],
      footer: [
        {
          dataType: DataColumnType.NONE
        },
        {
          dataType: DataColumnType.NONE
        },
        {
          dataType: DataColumnType.TEXT,
          class: 'text-center',
          getValue: () => this.getTotalPlazo()
        },
        {
          dataType: DataColumnType.NONE
        },
        {
          dataType: DataColumnType.NONE
        },
        {
          dataType: DataColumnType.NONE
        },
        {
          dataType: DataColumnType.NONE
        },
        {
          dataType: DataColumnType.NONE
        }
      ] as IFooterColums[]
    } as ICustomTable;
  }

  abrirHistorial(): void {
    this.historico.show(this.tipoTramiteId);
  }

  private getTotalPlazo(): string {
    if (!this.data || !this.tipoTramite) return '0';
    return ` ${this.data.reduce((acc, curr) => acc + curr.plazoFechaCierre, 0).toString()} / ${this.tipoTramite.plazo}`;
  }

  deleteConfirmation(event: Event, data: ITipoTramiteActividad) {
    this._cs.confirm({
      target: event.target as EventTarget,
      message: 'Estas seguro de que quieres eliminar la actividad?',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.removeActividad(data.id);
      },
      reject: () => {

      }
    });
  }

  private removeActividad(id: number) {
    this.data = this.data.filter(t => t.id !== id);
    let ordenIndex = 1;
    for (const data of this.data) {
      data.orden = ordenIndex;
      ordenIndex++;
    }
    this.btnGuardarDisable = false;
  }

  openNewActividadModal() {
    this.actividadBaseComponent.openNewModal(this.data);
  }

  openEditActividadModal(actividad: ITipoTramiteActividad) {
    this.actividadBaseComponent.openEditModal(this.data, actividad);
  }

  onGuardarCambios() {
    const request: TipoTramiteActividaDto[] = [];
    this.data.forEach(t => {
      let actividad = {
        actividadId: t.actividadId,
        orden: t.orden,
        plazoFechaCierre: t.plazoFechaCierre,
        tipoId: t.tipoId,
        respuestaDinamicaPlantillaId: t.respuestaDinamicaPlantillaId,
        respuestaDinamicaPlantillaVersion: t.respuestaDinamicaPlantillaVersion,
        respuestaDinamicaConfiguracionLlaves: t.respuestaDinamicaConfiguracionLlaves,
        insercionConfig: t.insercionConfig,
        actualizacionConfig: t.actualizacionConfig
      } as TipoTramiteActividaDto;

      if (t.tablaDinamicaConfigId) {
        actividad.automatico = {
          tablaDinamicaConfigId: t.tablaDinamicaConfigId,
          columnasVisibles: t.columnasVisibles,
          llavesConfig: t.llavesConfig,
          camposTexto: t.camposTexto,
          reporteLogoId: t.reporteLogoId
        }
      } else if (t.formularioId && t.formularioVersion) {
        actividad.general = {
          formularioId: t.formularioId,
          formularioVersion: t.formularioVersion
        }
      }

      request.push(actividad);
    });

    this.editarActividades(request);
    this.btnGuardarDisable = true;
  }

  onCancelarCambios() {
    this.data = this.dataset;
    this.btnGuardarDisable = true;
  }

  onSubmitEvent() {
    this.btnGuardarDisable = false;
  }

  //#region API Calls
  private editarActividades(request: TipoTramiteActividaDto[]) {
    this._lps.show(true);
    this._tt.editarActividades(this.tipoTramiteId, request).subscribe({
      next: (data: boolean) => {
        this._lps.hide();
        this.getTipoTramiteActividades();
        this.parentData.produccion = false;
        this._ms.add({ severity: 'success', summary: this.trans.exito, detail: this.trans.actividadesGuardadas });
      }
    });
  }

  private getTipoTramiteActividades() {
    this._tta.getTipoTramiteActividadByTipoTramiteId(this.tipoTramiteId).subscribe({
      next: (data: ITipoTramiteActividad[]) => {
        const parsedData = data.map(t => {
          const parsed = { ...t };
          if (typeof parsed.llavesConfig === 'string') {
            try {
              parsed.llavesConfig = JSON.parse(parsed.llavesConfig);
            } catch {
              parsed.llavesConfig = [];
            }
          }
          if (typeof parsed.camposTexto === 'string') {
            try {
              parsed.camposTexto = JSON.parse(parsed.camposTexto);
            } catch {
              parsed.camposTexto = [];
            }
          }
          if (typeof parsed.respuestaDinamicaConfiguracionLlaves === 'string') {
            try {
              parsed.respuestaDinamicaConfiguracionLlaves = JSON.parse(parsed.respuestaDinamicaConfiguracionLlaves);
            } catch {
              parsed.respuestaDinamicaConfiguracionLlaves = [];
            }
          }
          return parsed;
        });
        this.dataset = structuredClone(parsedData);
        this.data = structuredClone(parsedData);
      }
    });
  }

  private getTipoTramite() {
    this._tt.getTipoTramite(this.tipoTramiteId).subscribe({
      next: (data: ITipoTramite) => {
        this.tipoTramite = data;
      }
    });
  }

  //#endregion

  //#region alertas
  alertasMostrar(data: ITipoTramiteActividad): void {
    let alertas: String[] = [];
    if (!data.formularioIsLatest)
      alertas.push(this._t.instant('msg.alertaFormularioNoReciente'));     
    if(!data.respuestaDinamicaPlantillaIsLatest && data.respuestaDinamicaPlantillaId)
      alertas.push(this._t.instant('msg.alertaCorreoPlantillaNoReciente'));

    data.insercionConfig?.forEach(ic => {
      if(ic.formularioId === this.tipoTramite.formularioId && ic.formularioVersion !== this.tipoTramite.formularioVersion)
        alertas.push(this._t.instant('msg.crudInsercionNoReciente'));      
    });

    data.actualizacionConfig?.forEach(ac => {
      if(ac.formularioId === this.tipoTramite.formularioId && ac.formularioVersion !== this.tipoTramite.formularioVersion)
        alertas.push(this._t.instant('msg.crudActualizacionNoReciente'));   
    });
    this.alertasDialog.show(alertas);
  }

  alertasGetSeverity(data: ITipoTramiteActividad): Severity {
    let severity: Severity = 'success';
    if (!data.formularioIsLatest)
      severity = 'warning';    
    if(!data.respuestaDinamicaPlantillaIsLatest && data.respuestaDinamicaPlantillaId)
      severity = 'warning';

    data.insercionConfig?.forEach(ic => {
      if(ic.formularioId === this.tipoTramite.formularioId && ic.formularioVersion !== this.tipoTramite.formularioVersion)
        severity = 'warning';      
    });

    data.actualizacionConfig?.forEach(ac => {
      if(ac.formularioId === this.tipoTramite.formularioId && ac.formularioVersion !== this.tipoTramite.formularioVersion)
        severity = 'warning';
    });
    return severity;
  }
  //#endregion alertas

}
